define("shared/modifiers/button", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  /**
   *
   * @class ButtonModifier
   * @extends Modifier
   *
   * This applies CSS classes to the target element,
   * styling the element like a button, regardless of that element it is.
   *
   * Named Parameters:
   * @param {String} type Button color styling, Options: "primary", "default", "proceed", "outline", "danger", "mute", "unstyled" (default: "primary")
   * @param {String} size Button Size, Options: "small", "regular", "large" (default: "regular")
   * @param {String} additional Button options, Available options: "rounded", "circle", "block" (default: null)
   * @param {String} class Additional classes, in a space-delimeted string, that should be applied to this element.
   * Use this when applying additional dynamic classes to the element,
   * otherwise the dynamic class with override the classes created by the modifier.
   *
   * Examples:
   *
   * Simple Usage:
   *
   * Styles the `div` like a primary button
   * ```
   * <div {{button}}>
   * ```
   *
   * Using options:
   *
   * Styles the `div` like a small outline button that spans the width of it's container
   * ```
   * <div {{button type="outline" size="small" additional="block"}}></div>
   * ```
   *
   * Using classes:
   *
   * Styles the `div` like a large danger button with rounded corners. Also applies the "some", "extra", and "classes" classes
   * ```
   * <div {{button type="danger" size="large" additional="rounded" class="some extra classes"}}></div>
   * ```
   *
   */
  class ButtonModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "_previousType", void 0);

      _defineProperty(this, "_previousSize", void 0);

      _defineProperty(this, "_previousAdditional", void 0);

      _defineProperty(this, "prefix", 'o--btn');
    }

    get type() {
      var _types$this$args$name;

      const types = {
        primary: "".concat(this.prefix, "--primary"),
        default: "".concat(this.prefix, "--default"),
        proceed: "".concat(this.prefix, "--proceed"),
        outline: "".concat(this.prefix, "--outline"),
        danger: "".concat(this.prefix, "--danger"),
        mute: "".concat(this.prefix, "--mute"),
        unstyled: "".concat(this.prefix, "--a11y"),
        none: ''
      };
      return (_types$this$args$name = types[this.args.named.type]) !== null && _types$this$args$name !== void 0 ? _types$this$args$name : types.primary;
    }

    get size() {
      var _sizes$this$args$name;

      const sizes = {
        small: "".concat(this.prefix, "--sm"),
        regular: this.prefix,
        large: "".concat(this.prefix, "--lg"),
        none: ''
      };

      if (this.isUnstyled) {
        return sizes.none;
      }

      return (_sizes$this$args$name = sizes[this.args.named.size]) !== null && _sizes$this$args$name !== void 0 ? _sizes$this$args$name : sizes.regular;
    }

    get additional() {
      var _additionalOptions$th;

      const additionalOptions = {
        block: "".concat(this.prefix, "--block"),
        rounded: "".concat(this.prefix, "--r"),
        circle: "".concat(this.prefix, "--c")
      };
      return (_additionalOptions$th = additionalOptions[this.args.named.additional]) !== null && _additionalOptions$th !== void 0 ? _additionalOptions$th : '';
    }

    get classes() {
      const classes = this.args.named.class || '';
      return classes.split(' ').filter(cls => cls.length);
    }

    get isUnstyled() {
      return this.args.named.type === 'unstyled';
    }

    didUpdateArguments() {
      this._removeClasses();

      this._applyClasses();

      this._updatePrevious();
    }

    didInstall() {
      this._applyClasses();

      this._updatePrevious();
    }

    willRemove() {
      this._removeClasses();
    }

    _applyClasses() {
      const classes = [this.type, this.size, this.additional, ...this.classes].filter(cls => cls.length);
      this.element.classList.add(...classes);
    }

    _removeClasses() {
      const classes = [this._previousType, this._previousSize, this._previousAdditional, ...this._previousClasses].filter(cls => cls.length);
      this.element.classList.remove(...classes);
    }

    _updatePrevious() {
      this._previousType = this.type;
      this._previousSize = this.size;
      this._previousAdditional = this.additional;
      this._previousClasses = this.classes;
    }

  }

  _exports.default = ButtonModifier;
});